import * as Yup from 'yup';
import { APLHABET_PATTERN_REGEX, MOBILE_NUMBER_REGEX, TEXTAREA_LIMIT } from '../constants/common';

export const userProfileSchema = Yup.object({
  isAdmin: Yup.boolean(),
  isInterviewer: Yup.boolean(),
  firstName: Yup.string()
    .trim()
    .max(15, 'Must be 15 characters or less')
    .required('First Name is required.')
    .matches(APLHABET_PATTERN_REGEX, 'First name should only contain alphabetical characters.'),
  lastName: Yup.string()
    .trim()
    .max(20, 'Must be 20 characters or less')
    .required('Last Name is required.')
    .matches(APLHABET_PATTERN_REGEX, 'Last name should only contain alphabetical characters.'),
  email: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .required('Email Address is required.'),
  pmEmail: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .when('isInterviewer', {
      is: true,
      then: () => Yup.string().required('Email Address is required.'),
      otherwise: Yup.string()
    }),
  mobile: Yup.string()
    .trim()
    .matches(MOBILE_NUMBER_REGEX, 'Mobile Number Must Be 10 Digits Only.')
    .required('Mobile Number is required.'),
  gender: Yup.string(['1', '2']).required('Gender is required.'),
  address: Yup.string()
    .trim()
    .min(TEXTAREA_LIMIT.MIN, 'Address should be at least ${min} characters.')
    .max(TEXTAREA_LIMIT.MAX, 'Address should not exceed ${max} characters.'),
  yearsOfExperience: Yup.number().when('isAdmin', {
    is: false,
    then: Yup.number()
      .min(0, 'Minimum 0 Year.')
      .max(100, 'Maximum 100 Years.')
      .typeError('Only numbers are allowed.')
      .required('Exp. in Years is Required.')
  }),
  monthsOfExperience: Yup.number().when('isAdmin', {
    is: false,
    then: Yup.number()
      .min(0, 'Minimum 0 Month.')
      .max(11, 'Maximum 11 Months.')
      .required('Exp. in Months is required.')
      .typeError('Only numbers are allowed.')
  }),
  techStack: Yup.mixed().when('isHR', {
    is: true,
    then: Yup.array()
      .of(Yup.string('Should be of type string.'))
      .min(1, 'Please select at least one technology.')
      .required('Technologies are required.'),
    otherwise: Yup.array().of(Yup.string('Should be of type string.')).min(0)
  }),
  skills: Yup.mixed().when('isInterviewer', {
    is: true,
    then: Yup.array()
      .of(Yup.string('Should be of type string.'))
      .min(1, 'Please select at least one skill.')
      .required('Skills are required.'),
    otherwise: Yup.array().of(Yup.string('Should be of type string.')).min(0)
  }),
  profileImage: Yup.mixed().test(
    'format',
    'Only the following formats are accepted: .jpeg, .jpg, .png',
    (value) => {
      if (!value) {
        return true;
      }
      return (
        value &&
        (value.type === 'image/jpeg' || value.type === 'image/jpg' || value.type === 'image/png')
      );
    }
  )
});

export const updatePasswordSchema = Yup.object({
  oldPassword: Yup.string().required('Old Password is required.'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(/^(?=.*[a-z]).*$/, 'Password must contain at least one lowercase letter.')
    .matches(/^(?=.*[A-Z]).*$/, 'Password must contain at least one uppercase letter.')
    .matches(/^(?=.*\d).*$/, 'Password must contain at least one digit.')
    .matches(
      /^(?=.*[!@#$%^&*()\-_=+{};:,<.>/?]).*$/,
      'Password must contain at least one special character.'
    )
    .matches(/^\S*$/, 'Password cannot contain spaces.'),
  confirmPassword: Yup.string()
    .required('Confirm Password is required.')
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
});
